import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCustomer} from '../hooks/useCustomer.ts';
import {useCustomersSelection} from '../hooks/useCustomersSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {
        record: customer,
        loading,
        updateRecord,
    } = useCustomer(customerId);

    const {handleClearSelection} = useCustomersSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (loading || !customer) {
        return <PlatformLoader message='Loading customer...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={customer.name ? customer.name : customer.id}
            pageNavigation={<EditPageNavigation component={customer}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>

                    <Profile
                        record={customer}
                        onRecordUpdate={(updates) => {
                            const updatedCustomer = { ...customer, ...updates };
                            updateRecord(updatedCustomer);
                        }}
                    />
                    {/*
                    <AccountsPage/>
                    */}

                </Stack>
                :
                <RecordForm
                    record={customer}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};